// extracted by css-extract-rspack-plugin
export default {"customerCodeStyle":"Header__customerCodeStyle--Y87zC","link":"Header__link--GVei0","email":"Header__email--KOksU"};